import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { PopupService } from '../../../services/popup.service';
import { MapService } from '../../../services/map.service';
import { MyStuffService } from '../../../services/my-stuff.service';
import { NotificationService } from '../../../services/notification.service';
import { BaseService } from '../../../services/base.service';
import { LoaderService } from '../../../services/loader.service';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../../validators/custom-validators';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { CustErrorHandler } from '../../../app.error.handler';
import { UserService } from '../../../services/user.service';
import { FeatureService } from '../../../services/feature.service';
import { Observable } from 'rxjs/Observable';
import { SegmentEvents }from '../../../constants/SegmentEvents';
import { SegmentService } from '../../../services/segment.service';

@Component({
  selector: 'app-share-map',
  templateUrl: './share-map.component.html',
  styleUrls: ['./share-map.component.less'],
  providers: [CustErrorHandler],
  encapsulation: ViewEncapsulation.None
})
export class ShareMapComponent implements OnInit {

  constructor(public popupService: PopupService, public formBuilder: FormBuilder,
    public mapService: MapService, public myStuffService: MyStuffService,
    public errHandler: CustErrorHandler, public userService: UserService,
    public notificationService: NotificationService, public featureService: FeatureService,
    public baseService: BaseService, public segmentService: SegmentService, public loaderService: LoaderService) { }

  shareEmailForm: FormGroup;
  shareLinkForm: FormGroup;
  shareEmbedForm: FormGroup;
  name: string;
  emailRecipients: string;
  message: string;
  isSharing: boolean = false;
  submitted: boolean = false;
  shareMapChangeSubscription: Subscription;
  shareLink: string;
  embedLink: string;
  shareLinkCopyMessage: string = 'Copy Link To Clipboard';
  embedLinkCopyMessage: string = 'Copy Code To Clipboard';
  shareMapFeatureSubscription: Subscription;

  nameMaxLength: number = 59;
  messageMaxLength: number = 1020;

  ngOnInit() {
    this.initializeForms();
    this.initializeSubscriptions();
  }

  ngAfterViewInit() {
    this.initializeShareEmailObservables();
    this.initializeShareLinkObservables();
    this.initializeShareEmbedObersvables();
  }

  initializeShareEmailObservables() {
    let shareEmailNameInput: any = document.getElementById('share-email-name-input'),
        shareEmailRecipentsInput: any = document.getElementById('share-email-recipients-input'),
        shareEmailMessageInput: any = document.getElementById('share-email-message-input');

    if(shareEmailNameInput) {
      Observable.fromEvent(shareEmailNameInput, 'input')
      .subscribe((e: any) => {
        if((shareEmailNameInput.classList.contains('field-label-error') && (shareEmailNameInput.value.length>0 || shareEmailNameInput.value.length <= this.nameMaxLength))
          || shareEmailNameInput.value.length === 0
          || (shareEmailNameInput.value.length > this.nameMaxLength)) {
          (<any>window).Events.publish('detectChanges');
        }
      });
    }

    if(shareEmailRecipentsInput) {
      Observable.fromEvent(shareEmailRecipentsInput, 'input')
      .subscribe((e: any) => {
        (<any>window).Events.publish('detectChanges');
      });
    }

    if(shareEmailMessageInput) {
      Observable.fromEvent(shareEmailMessageInput, 'input')
      .subscribe((e: any) => {
        if((shareEmailMessageInput.classList.contains('field-label-error') && (shareEmailMessageInput.value.length>0 || shareEmailMessageInput.value.length <= this.nameMaxLength))
         || shareEmailMessageInput.value.length === 0
         || shareEmailMessageInput.value.length > this.messageMaxLength) {
          (<any>window).Events.publish('detectChanges');
        }
      });
    }
  }

  initializeShareLinkObservables() {
    let shareLinkNameInput: any = document.getElementById('share-link-name-input');
    if(shareLinkNameInput) {
      Observable.fromEvent(shareLinkNameInput, 'input')
      .subscribe((e: any) => {
        if((shareLinkNameInput.classList.contains('field-label-error') && (shareLinkNameInput.value.length>0 || shareLinkNameInput.value.length <= this.nameMaxLength))
          || shareLinkNameInput.value.length === 0
          || shareLinkNameInput.value.length > this.nameMaxLength) {
          (<any>window).Events.publish('detectChanges');
        }
      });
    }
  }

  initializeShareEmbedObersvables() {
    let shareEmbedNameInput: any = document.getElementById('share-embed-name-input');
    if(shareEmbedNameInput) {
      Observable.fromEvent(shareEmbedNameInput, 'input')
      .subscribe((e: any) => {
        if((shareEmbedNameInput.classList.contains('field-label-error') && (shareEmbedNameInput.value.length>0 || shareEmbedNameInput.value.length <= this.nameMaxLength))
          || shareEmbedNameInput.value.length === 0
          || shareEmbedNameInput.value.length > this.nameMaxLength) {
          (<any>window).Events.publish('detectChanges');
        }
      });
    }
  }

  initializeForms() {
    this.shareEmailForm = this.formBuilder.group({
      name: [this.name, Validators.compose([Validators.required, Validators.maxLength(this.nameMaxLength)])],
      emailRecipients : [this.emailRecipients, Validators.compose([Validators.required, CustomValidators.emailRecipients])],
      message : [this.message, Validators.compose([Validators.maxLength(this.messageMaxLength)])]
    });
    this.shareLinkForm = this.formBuilder.group({
      name: [this.name, Validators.compose([Validators.required, Validators.maxLength(this.nameMaxLength)])],
    });
    this.shareEmbedForm = this.formBuilder.group({
      name: [this.name, Validators.compose([Validators.required, Validators.maxLength(this.nameMaxLength)])],
    });
  }

  initializeSubscriptions() {
    this.shareMapChangeSubscription = this.mapService.shareMapChangeStream.subscribe((value)=>{
      this.submitted = false;
      (value && this.mapService.currentUserMap)? this.shareEmailForm.controls['name'].disable() : this.shareEmailForm.controls['name'].enable();
      (value && this.mapService.currentUserMap)? this.shareLinkForm.controls['name'].disable() : this.shareLinkForm.controls['name'].enable();
      (value && this.mapService.currentUserMap)? this.shareEmbedForm.controls['name'].disable() : this.shareEmbedForm.controls['name'].enable();
      this.shareLink = (value && this.mapService.currentUserMap)?
      environment.APP.WEB_APP_URL+'/map?m='+this.mapService.currentUserMap.accessId: '';
      this.embedLink = (value && this.mapService.currentUserMap)?
      '<iframe width="100%" height="100%" src="'+(environment.APP.EMBED_APP_URL+this.mapService.currentUserMap.accessId)+'" frameborder="0" allowfullscreen></iframe>':'';
      this.name = (value)? (this.mapService.currentUserMap ?this.mapService.currentUserMap.name: this.name) : '';
      this.resetCopyToClipboardMessage();
      setTimeout(()=>{
        this.baseService.focusFirstEmptyElement('share-form-input');
      },0);
    });

    this.shareMapFeatureSubscription = this.featureService.shareMapFeatureChangeStream.subscribe((data)=>{
      if(data) {
        this.isSharing = true;
        this.loaderService.addGreyLoaderClass();
        (<any>window).Events.publish('detectChanges');
        this.mapService.shareMap(data).subscribe((response)=>{
          this.isSharing = false;
          this.notificationService.info('Your map is Shared');
          this.loaderService.removeGreyLoaderClass();
          this.closePopup();
        },(error)=>{
          this.isSharing = false;
          this.loaderService.removeGreyLoaderClass();
          this.errHandler.handleError(error);
        });
      }
    });
  }

  closePopup() {
    this.submitted = false;
    this.shareEmailForm.reset();
    this.shareLinkForm.reset();
    this.shareEmbedForm.reset();
    this.popupService.updateRoute();
  }

  resetCopyToClipboardMessage() {
    this.shareLinkCopyMessage = 'Copy Link To Clipboard';
    this.embedLinkCopyMessage = 'Copy Link To Clipboard';
  }

  switchInnerSection(event) {
    if(this.userService.getLoggedIn()) {
      this.popupService.updateRoute('share-map',event.target.dataset.section);
    } else {
      this.popupService.updateRoute('sign-up');
    }
  }

  copyToClipboard(toggle) {
    if(this.mapService.currentUserMap) {
       (toggle === 'link') ? this.shareLinkCopyMessage = 'Copied!' : this.embedLinkCopyMessage = 'Copied!';
       (<any>window).Events.publish('detectChanges')
    } else {
      if(toggle === 'link') {
        this.saveAndGetLink();
      } else if(toggle === 'embed') {
        this.saveAndGetEmbed();
      }
    }
  }

  selectText(element) {
    var doc = document;
    var text = doc.getElementById(element);

    if (window.getSelection) { // moz, opera, webkit
      var selection = window.getSelection();
      var range = doc.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  onSubmit() {
    let w = (<any>window);
    this.submitted = true;
    if(this.shareEmailForm.valid) {
      let map;
      this.isSharing = true;
      this.loaderService.addGreyLoaderClass();
      w.Events.publish('detectChanges');
      if(this.mapService.currentUserMap) {
        map = {
          name: this.mapService.currentUserMap.name,
          id: this.mapService.currentUserMap.id,
          mapShares:[]
        };
      } else {
        w.saveMap.updateMapData();
        map = {
          name: this.name,
          mapData: [],
          mapShares: []
        };
        w.saveMap.setMapDataRotateValue();
        map.mapData = w.saveMap.convertMapDataToKeyValue();
      }
      let emailers = this.emailRecipients.split(',');
      emailers.forEach((email)=>{
        map.mapShares.push({
          recipientEmail: email.trim(),
          message: this.message
        });
      });
      this.mapService.shareMap(map).subscribe((response)=>{
        this.isSharing = false;
        this.segmentService.log(SegmentEvents.mapShared, {
          map_id: map.id,
          type: 'email',
          num_recipients: map.mapShares.length,
          email_recipients:this.emailRecipients.split(','),
        });
        this.notificationService.info('Your map is Shared');
        this.loaderService.removeGreyLoaderClass();
        this.closePopup();
        w.Events.publish('detectChanges');
      },(error)=>{
        this.isSharing = false;
        this.loaderService.removeGreyLoaderClass();
        if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
          this.featureService.updateFeature('share-map');
          this.featureService.updateExecutionFeature('share-map', map);
        }
        this.errHandler.handleError(error);
        w.Events.publish('detectChanges');
      });
    } else {
      w.Events.publish('detectChanges');
    }
  }

  saveAndGetLink() {
    let w = (<any>window);
    this.submitted = true;
    if(this.shareLinkForm.valid) {
      this.isSharing = true;
      this.loaderService.addGreyLoaderClass();
      w.Events.publish('detectChanges');
      let map;
      w.saveMap.updateMapData();
      map = {
        name: this.name,
        mapData: [],
        mapShares: []
      };
      w.saveMap.setMapDataRotateValue();
      map.mapData = w.saveMap.convertMapDataToKeyValue();
      this.mapService.saveMap(map).subscribe((response)=>{
        this.isSharing = false;
        this.loaderService.removeGreyLoaderClass();
        this.userService.onSingleMapClick(response, null, true);
        this.segmentService.log(SegmentEvents.mapShared, {
          map_id: map.id,
          type: 'link'
        });
        this.notificationService.info('Your map is Saved');
        w.Events.publish('detectChanges');
      },(error)=>{
        this.isSharing = false;
        this.loaderService.removeGreyLoaderClass();
        if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
          this.featureService.updateFeature('save-map');
        }
        this.errHandler.handleError(error);
        w.Events.publish('detectChanges');
      });
    } else {
      w.Events.publish('detectChanges');
    }
  }

  saveAndGetEmbed() {
    let w = (<any>window);
    this.submitted = true;
    if(this.shareEmbedForm.valid) {
      this.isSharing = true;
      this.loaderService.addGreyLoaderClass();
      w.Events.publish('detectChanges');
      let map;
      w.saveMap.updateMapData();
      map = {
        name: this.name,
        mapData: [],
        mapShares: []
      };
      w.saveMap.setMapDataRotateValue();
      map.mapData = w.saveMap.convertMapDataToKeyValue();
      this.mapService.saveMap(map).subscribe((response)=>{
        this.isSharing = false;
        this.userService.onSingleMapClick(response, null, true);
        this.myStuffService.mapEntriesAvailable[this.myStuffService.mapCallFilters.allMaps] = true;
        this.loaderService.removeGreyLoaderClass();
        this.segmentService.log(SegmentEvents.mapShared, {
          map_id: map.id,
          type: 'embed'
        });
        this.notificationService.info('Your map is Saved');
        w.Events.publish('detectChanges');
      },(error)=>{
        this.isSharing = false;
        this.loaderService.removeGreyLoaderClass();
        if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
          this.featureService.updateFeature('save-map');
        }
        this.errHandler.handleError(error);
        w.Events.publish('detectChanges');
      });
    } else {
      w.Events.publish('detectChanges');
    }
  }

  ngOnDestroy() {
    this.shareMapChangeSubscription && this.shareMapChangeSubscription.unsubscribe();
    this.shareMapFeatureSubscription && this.shareMapFeatureSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/share-map/share-map.component.ts